import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { isNullish } from 'wflow-cdk';
import { APP_ROUTES } from 'wflow-main-app/src/app/routing.const';
import { OrganizationsStore } from '../../store/organizations/organizations.model';
import { selectAllOrganizationsExpired } from '../../store/organizations/organizations.selectors';

@Injectable()
export class TrialPeriodExpiredGuard {
  constructor(
    public router: Router,
    public store: Store<OrganizationsStore>,
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#redirect();
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.#redirect();
  }

  #redirect() {
    return this.store.select(selectAllOrganizationsExpired).pipe(
      filter((options) => !isNullish(options)),
      take(1),
      map((allOrganizationsExpired) => {
        if (allOrganizationsExpired) {
          return this.router.createUrlTree([APP_ROUTES.EXPIRED]);
        }

        return true;
      }),
    );
  }
}
